import { clsx } from 'clsx';
import { FC } from 'react';
import { LandingHeroStoryblok } from 'storyblok-types';
import { H2 } from 'atoms/Typography';
import styles from './styles.module.css';

export const LandingHero: FC<{ blok: LandingHeroStoryblok }> = ({ blok }) => {
  return (
    <div className={clsx(styles.root, styles.container)}>
      <H2 className={styles.headline}>{blok.title}</H2>
    </div>
  );
};
